module.exports = __webpack_public_path__ + "img/palm2_3.1189682d.png";